import NutSeedButtersProduct from 'models/NutSeedButtersProduct'

export const packagingInitialState = {
  category: NutSeedButtersProduct.category,
  subCategory: NutSeedButtersProduct.subCategory,
  Iron: NutSeedButtersProduct.Iron,
  Protein: NutSeedButtersProduct.Protein,
  Texture: {
    value: NutSeedButtersProduct.Texture,
    label: 'Texture',
  },
  OtherTexture: NutSeedButtersProduct.OtherTexture,
  Size: NutSeedButtersProduct.Size,
}

export const typeOptions = [
  {
    value: '',
    label: 'Nut or Seed Butter Type',
    isDisabled: true,
  },
  {
    value: 'Almond butter',
    label: 'Almond butter',
  },
  {
    value: 'Sunflower seed butter',
    label: 'Sunflower seed butter',
  },
]

export const textureOptions = [
  {
    value: '',
    label: 'Texture',
    isDisabled: true,
  },
  {
    value: 'Creamy',
    label: 'Creamy',
  },
  {
    value: 'Chunky',
    label: 'Chunky',
  },
  {
    value: 'Smooth',
    label: 'Smooth',
  },
  {
    value: 'Natural',
    label: 'Natural',
  },
  {
    value: 'Other',
    label: 'Other',
  },
]
